import { useContext, useCallback } from 'react';
import { message } from 'antd';
import eventBus from '@liepin/js-eventbus-fe';
import { apicRoot, cRoot, ajax } from '@liepin/js-core4c-fe';
import { LOGIN_SUCCESS } from '@liepin/js-eventbus-fe/enum';
import localCookie from '@liepin/native-sweet-fe'
import LoginContext from '../../store/context/LoginContext';
import { AgreementKey } from '../../modules/const';
import { ELoginType } from '../../enum';



const useLogin = () => {

  const { state: {
      checkedAgreement, loginType, onSuccess, onRegister, onLogin,
      handleCloseModal, isModal, loginIndexMark, skipCheckResumeComplete,
    },
    dispatch
  } = useContext(LoginContext) || {};

  // 切换用户协议勾选
  const changeCheckedAgreement = (val) => {
    dispatch({ payload: {
      checkedAgreement: val
    }})
  }

  // 切换登录方式
  const changeLoginType = useCallback((val) => {
    dispatch({ payload: {
      loginType: val
    }})
  }, [dispatch])

  // 二维码切换
  const handleSwitchLoginType = useCallback(() => {
    if (loginType === ELoginType.Qrcode) {
      changeLoginType(ELoginType.Reg)
    } else {
      changeLoginType(ELoginType.Qrcode)
    }
  }, [loginType, changeLoginType])

  const checkResumeComplete = useCallback((callback) => {
    if (skipCheckResumeComplete) {
      // 跳过检验完简
      callback();
    } else {
      ajax.get(`${apicRoot}/api/com.liepin.cresume.resume-complete-flag`)
      .then(({ data }) => {
        if (data.intercepted) {
          // 需要完简 跳转到五步走页面
          const backUrl = encodeURIComponent(window.location.href);
          window.location.href = `${cRoot}/resume-complete/page/?backUrl=${backUrl}`;
        } else {
          callback();
        }
      }).catch(() => {
        // 获取失败，直接走登录成功后续
        callback();
      })
    }
  }, [skipCheckResumeComplete])

  // 登录成功 data.type 0 注册 1 登录
  const loginSuccess = useCallback((data) => {
    // 登录成功、校验是否完简
    checkResumeComplete(() => {
      // 记住用户协议勾选
      localCookie.set(AgreementKey, 1)
      // 是弹窗时关闭弹窗
      isModal && handleCloseModal && handleCloseModal();
      // 登录事件
      onSuccess && onSuccess(data);
      if (data.type === '0') {
        // 新用户注册成功事件
        onRegister && onRegister(data)
      } else {
        // 老用户登录成功事件
        onLogin && onLogin(data)
      }
      // 发PC全局通知-登录成功
      eventBus.emit(LOGIN_SUCCESS, { data, isModal })
    })
  }, [onSuccess, onRegister, onLogin, isModal, handleCloseModal, checkResumeComplete])

  // 登录失败
  const loginError = useCallback(({ msg }) => {
    msg && message.error(msg)
  }, [])

  return {
    // 用户协议
    checkedAgreement,
    changeCheckedAgreement,
    // 登录方式
    loginType,
    changeLoginType,
    handleSwitchLoginType,
    // 登录成功/失败
    loginSuccess,
    loginError,
    // 登录弹窗
    handleCloseModal,
    isModal,
    loginIndexMark,
  };
};

export default useLogin;